// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dYd8","title":"Info_title__y3ncX","links":"Info_links__3OYue","link":"Info_link__2kTJX","logo":"Info_logo__1avhq"};